import { render, staticRenderFns } from "./LinkDetails.vue?vue&type=template&id=1ccd825e&scoped=true&"
import script from "./LinkDetails.vue?vue&type=script&lang=js&"
export * from "./LinkDetails.vue?vue&type=script&lang=js&"
import style0 from "./LinkDetails.vue?vue&type=style&index=0&id=1ccd825e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccd825e",
  null
  
)

export default component.exports